/* Navigation helpers: mobile drawer accessibility + desktop keyboard support.
   global.js already toggles .is-open on #MobileDrawer; this file reacts to that
   class so the two never fight. */
(function () {
  var drawer = document.getElementById('MobileDrawer');
  var lastFocus = null;
  var wantSearch = false;

  function openers() { return document.querySelectorAll('[data-drawer-open]'); }

  if (drawer) {
    var panel = drawer.querySelector('.drawer__panel') || drawer;

    openers().forEach(function (b) {
      b.addEventListener('click', function () {
        wantSearch = b.hasAttribute('data-focus-search');
        lastFocus = b;
      });
    });

    var sync = function () {
      var isOpen = drawer.classList.contains('is-open');
      document.body.classList.toggle('nav-open', isOpen);
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      openers().forEach(function (b) { b.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); });
      if (isOpen) {
        setTimeout(function () {
          var target = wantSearch ? drawer.querySelector('input[type="search"]') : drawer.querySelector('.drawer__close');
          if (target) target.focus();
          wantSearch = false;
        }, 80);
      } else if (lastFocus && document.contains(lastFocus)) {
        lastFocus.focus();
      }
    };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();

    /* One section open at a time (fallback for browsers without <details name>). */
    drawer.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open || !d.name) return;
      drawer.querySelectorAll('details[name="' + d.name + '"]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);

    /* Escape closes; Tab stays inside the open drawer. */
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { drawer.classList.remove('is-open'); return; }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), summary'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* Desktop mega menu: reflect open state for assistive tech; Escape closes it. */
  document.querySelectorAll('.nav__item.has-mega').forEach(function (item) {
    var link = item.querySelector(':scope > a');
    if (!link) return;
    function set(v) { link.setAttribute('aria-expanded', v ? 'true' : 'false'); }
    item.addEventListener('mouseenter', function () { set(true); });
    item.addEventListener('mouseleave', function () { set(false); });
    item.addEventListener('focusin', function () { set(true); });
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) set(false); });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        set(false);
        var a = document.activeElement;
        if (a && a.blur) a.blur();
      }
    });
  });
})();
